module.exports = __webpack_public_path__ + "static/media/luxury.2fd4beee.svg";